import { render, staticRenderFns } from "./HomeFeatures.vue?vue&type=template&id=38bef68d&"
import script from "./HomeFeatures.vue?vue&type=script&lang=js&"
export * from "./HomeFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports